import { render, staticRenderFns } from "./AgentsContainer.vue?vue&type=template&id=f1e2deb2&"
import script from "./AgentsContainer.vue?vue&type=script&lang=js&"
export * from "./AgentsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports